import { Injectable } from '@angular/core';
import { DisordersTranslationMap } from '../models/disorders.enum.translation';

@Injectable({
  providedIn: 'root'
})
export class DisordersTranslationService {

  constructor() { }

  public translateDisordersEnum(disorders: string[]): string[] {
    let translation: string[] = [];
    Array.from(DisordersTranslationMap.entries())
      .filter(m => disorders.includes(m[0]))
      .forEach(m => {
        translation.push(m[1])
      })
    return translation;
  }

}
